import { createSelector } from 'reselect';

import { RootState } from '@ezugi/bootstrap';

import { MAX_CARDS_NUMBER } from '../../constants/cards';
import { CardsState } from '../reducers/cards';

type RootStateWithCards = RootState & { cards: CardsState };

export const cardsSelector = (state: RootStateWithCards) => state.cards;

export const playerACardsSelector = createSelector(
  cardsSelector,
  (cards) => cards['Player A']
);

export const playerBCardsSelector = createSelector(
  cardsSelector,
  (cards) => cards['Player B']
);

export const numberOfCardsSelector = createSelector(
  playerACardsSelector,
  playerBCardsSelector,
  (playerACards, playerBCards) => (playerACards.cards.length + playerBCards.cards.length) || 0
);

export const hasReachedCardsLimitSelector = createSelector(
  numberOfCardsSelector,
  (nrOfCards) => nrOfCards === MAX_CARDS_NUMBER,
);
